import { computed, ref } from 'vue'
import { useIntersectionObserver } from '@vueuse/core'

export function useStickyGridFiltersBar() {
    const gridTopBarWrapperEl = ref(null)
    const gridEl = ref(null)
    const isGridTopBarStuck = ref(false)
    const gridTopBarHeight = '70px' as const

    useIntersectionObserver(
        gridTopBarWrapperEl,
        ([entry]) => {
            if (!entry) {
                return
            }

            isGridTopBarStuck.value = entry.isIntersecting
        },
        {
            root: gridEl,
            rootMargin: `-${gridTopBarHeight} 0px 0px 0px`,
            threshold: 0.1,
        }
    )

    const classGridTopBarWrapper = computed(() => ({
        'stuck': isGridTopBarStuck.value,
    }))

    return {
        gridTopBarWrapperEl,
        gridEl,
        classGridTopBarWrapper,
        gridTopBarHeight,
    }
}
